import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsSystemDefaultSettingsRoute: InvariantJiraRoute = {
	name: 'global-settings-system-default-settings',
	path: '/secure/admin/ViewUserDefaultSettings([!%]?[\\w]*).jspa',
};
